/* src/app/global-news/global-news.component.css */
#benchmarkContainer {
  height: 60rem;
  width: 100%;
}
#legendItems {
  font-size: medium;
  text-align: left;
}
.legendRed {
  color: red;
}
.legendGreen {
  color: green;
}
@media (max-width: 767px), screen and (max-width: 812px) and (orientation: landscape) {
  #benchmarkContainer {
    height: 50rem;
  }
}
#legend {
  margin-left: 10rem;
  padding-left: 1rem;
  color: white;
}
@media (max-width: 767px), screen and (max-width: 812px) and (orientation: landscape) {
  #legend {
    margin-left: 0rem;
    padding-left: 1rem;
    color: white;
  }
}
.legendGrad {
  background-image:
    linear-gradient(
      to right,
      #BACEE7,
      #ACC0E1,
      white);
}
.legendShadow {
  box-shadow: 1px 2px 14px rgba(0, 0, 0, .5);
}
.legendRed {
  color: red;
}
.legendGreen {
  color: green;
}
#legendItems {
  width: 100%;
}
#benchmarkContainer {
  height: 75rem;
  width: 100%;
}
@media (max-width: 767px), screen and (max-width: 812px) and (orientation: landscape) {
  #benchmarkContainer {
    height: 50rem;
  }
}
.brochurePos {
  margin-left: 0rem;
}
@media (max-width: 767px), screen and (max-width: 812px) and (orientation: landscape) {
  .brochurePos {
    margin-left: 2.5rem;
  }
}
#about {
}
.nsdqChart {
  width: 840px;
  height: 680px;
}
@media (max-width: 767px), screen and (max-width: 812px) and (orientation: landscape) {
  .nsdqChart {
    width: 100%;
    height: 280px;
  }
  .highcharts-legend {
    pointer-events: none;
  }
}
.chart .chart__head {
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1.5rem;
  display: block;
}
.hide {
  display: none;
}
/*# sourceMappingURL=global-news.component.css.map */
